import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import CtaToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const BannerSettings = (settingsProps) => {
  const optionsTheme = [
    {
      label: 'White',
      value: 'white',
    },
    {
      label: 'Neutral10',
      value: 'neutral10',
    },
    {
      label: 'Neutral20',
      value: 'neutral20',
    },
  ]
  const optionsPos = [
    {
      label: '-',
      value: '',
    },
    {
      label: 'Reverse',
      value: 'reverse',
    },
  ]
  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="theme"
          type="select"
          options={optionsTheme}
          label="Tema"
          defaultValue={defaultProps['theme']}
        />
      </ToolbarSection>
      {!settingsProps.floating && (
        <>
          <ImageToolbarSection defaultProps={defaultProps} />
          <CtaToolbarSection defaultProps={defaultProps} />
        </>
      )}
    </>
  )
}

export const BannerFloatingSettings = () => React.createElement(BannerSettings, { floating: true })
